import { useEffect, useLayoutEffect, useRef } from 'react';

/** Calls `callback` every `delay` ms, first after one `delay`. `null` pauses it. */
export function useSetInterval(callback: () => void, delay: number | null): void {
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (delay == null) return;
    const id = setInterval(() => callbackRef.current(), delay);
    return () => clearInterval(id);
  }, [delay]);
}
